import type { Dispatch as ReduxDispatch } from "redux";
import { ActionTypes } from "../constants";
import { NavigateFunction } from "react-router";

interface AuthnzConfirmRegistrationAction {
  type: "AUTHNZ_CONFIRM_REGISTRATION";
  navigate: NavigateFunction;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: Record<string, any>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const authnzConfirmRegistration = (data: Record<string, any>, navigate: NavigateFunction): AuthnzConfirmRegistrationAction => {
  return {
    type: ActionTypes.AUTHNZ_CONFIRM_REGISTRATION,
    payload: data,
    navigate,
  };
};

interface AuthnzForgotPasswordAction {
  type: "AUTHNZ_FORGOT_PASSWORD";

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: Record<string, any>;
  navigate: NavigateFunction;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const authnzForgotPassword = (data: Record<string, any>, navigate: NavigateFunction): AuthnzForgotPasswordAction => {
  return {
    type: ActionTypes.AUTHNZ_FORGOT_PASSWORD,
    payload: data,
    navigate,
  };
};

interface AuthnzForgotPasswordResetAction {
  type: "AUTHNZ_FORGOT_PASSWORD_RESET";
  navigate: NavigateFunction;
}

export const authnzForgotPasswordReset = (navigate: NavigateFunction): AuthnzForgotPasswordResetAction => {
  return {
    type: ActionTypes.AUTHNZ_FORGOT_PASSWORD_RESET,
    navigate,
  };
};

interface AuthnzResendCodeAction {
  type: "AUTHNZ_RESEND_CODE";

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: Record<string, any>;
  navigate: NavigateFunction;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const authnzResendCode = (data: Record<string, any>, navigate: NavigateFunction): AuthnzResendCodeAction => {
  return {
    type: ActionTypes.AUTHNZ_RESEND_CODE,
    payload: data,
    navigate,
  };
};

interface AuthnzSetNewPasswordRequiredAction {
  type: "AUTHNZ_SET_NEW_PASSWORD_REQUIRED";

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: Record<string, any>;
  navigate: NavigateFunction;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const authnzSetNewPasswordRequired = (data: Record<string, any>, navigate: NavigateFunction): AuthnzSetNewPasswordRequiredAction => {
  return {
    type: ActionTypes.AUTHNZ_SET_NEW_PASSWORD_REQUIRED,
    payload: data,
    navigate,
  };
};

interface AuthnzUpdatePasswordAction {
  type: "AUTHNZ_UPDATE_PASSWORD";

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: Record<string, any>;
  navigate: NavigateFunction;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const authnzUpdatePassword = (data: Record<string, any>, navigate: NavigateFunction): AuthnzUpdatePasswordAction => {
  return {
    type: ActionTypes.AUTHNZ_UPDATE_PASSWORD,
    payload: data,
    navigate,
  };
};

interface AuthnzUserSignInAction {
  type: "AUTHNZ_USER_SIGN_IN";
  navigate: NavigateFunction;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: Record<string, any>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const authnzUserSignIn = (data: Record<string, any>, navigate: NavigateFunction): AuthnzUserSignInAction => {
  return {
    type: ActionTypes.AUTHNZ_USER_SIGN_IN,
    payload: data,
    navigate,
  };
};

interface AuthnzUserLogoutAction {
  type: "AUTHNZ_USER_LOG_OUT";
  navigate: NavigateFunction;
}

export const userLogout = (navigate: NavigateFunction): AuthnzUserLogoutAction => {
  return {
    type: ActionTypes.AUTHNZ_USER_LOG_OUT,
    navigate,
  };
};

interface AuthnzUserSignUpAction {
  type: "AUTHNZ_USER_SIGN_UP";

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: Record<string, any>;
  navigate: NavigateFunction;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const authnzUserSignUp = (data: Record<string, any>, navigate: NavigateFunction): AuthnzUserSignUpAction => {
  return {
    type: ActionTypes.AUTHNZ_USER_SIGN_UP,
    payload: data,
    navigate,
  };
};

export type Action =
  | AuthnzConfirmRegistrationAction
  | AuthnzForgotPasswordAction
  | AuthnzForgotPasswordResetAction
  | AuthnzResendCodeAction
  | AuthnzSetNewPasswordRequiredAction
  | AuthnzUpdatePasswordAction
  | AuthnzUserLogoutAction
  | AuthnzUserSignInAction
  | AuthnzUserSignUpAction;

export type Dispatch = ReduxDispatch<Action>;
